import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/wcandillon/tmp/tmp/react-native-redash/packages/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "transitions"
    }}>{`Transitions`}</h1>
    <p>{`Transitions are essential to the user experience.
Redash offers four utility functions for transitions which are broke down in the table below.
If you want to build a transition based on a React state change use `}<inlineCode parentName="p">{`useTimingTransition()`}</inlineCode>{` or `}<inlineCode parentName="p">{`useSpringTransition()`}</inlineCode>{`.
To transition an animation value change, use `}<inlineCode parentName="p">{`withTimingTransition()`}</inlineCode>{` or `}<inlineCode parentName="p">{`withSpringTransition()`}</inlineCode>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`State (JS Thread)`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`Value (UI Thread)`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Timing`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`useTimingTransition()`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`withTimingTransition()`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Spring`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`useSpringTransition()`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`withSpringTransition()`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "attach-a-transition-to-a-state"
    }}>{`Attach a transition to a state`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import {useTimingTransition} from "react-native-redash";

const Toggle = () => {
  const [open, setOpen] = useState(false);
  const transition = useTimingTransition(open, { duration: 400 });
}
`}</code></pre>
    <h2 {...{
      "id": "attach-a-transition-to-an-animation-value"
    }}>{`Attach a transition to an animation value`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import {withTimingTransition} from "react-native-redash";

const Toggle = () => {
  const open = new Value<number>(0);
  const transition = withTimingTransition(open, { duration: 400 });
}
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "usetimingtransition"
    }}><inlineCode parentName="h2">{`useTimingTransition()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const useTimingTransition: (state: number | boolean, config?: Partial<Pick<Animated.TimingConfig, "duration" | "easing">>) => Animated.Node<number>;
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "usespringtransition"
    }}><inlineCode parentName="h2">{`useSpringTransition()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const useSpringTransition: (state: number | boolean, config?: Partial<Pick<Animated.SpringConfig, "damping" | "mass" | "stiffness" | "overshootClamping" | "restSpeedThreshold" | "restDisplacementThreshold">>) => Animated.Node<number>;
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "withtimingtransition"
    }}><inlineCode parentName="h2">{`withTimingTransition()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const withTimingTransition: (value: Animated.Node<number>, timingConfig?: Partial<Pick<Animated.TimingConfig, "duration" | "easing">>, gestureState?: Animated.Value<State>) => Animated.Node<number>;
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "withspringtransition"
    }}><inlineCode parentName="h2">{`withSpringTransition()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const withSpringTransition: (value: Animated.Node<number>, springConfig?: Partial<Pick<Animated.SpringConfig, "damping" | "mass" | "stiffness" | "overshootClamping" | "restSpeedThreshold" | "restDisplacementThreshold">>, velocity?: Animated.Adaptable<number>, gestureState?: Animated.Value<State>) => Animated.Node<number>;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      